import performReauth from './performReauth';
const reauthDebouncerThreshold = 500;
function setGlobalReauthPromise(promise) {
    if (typeof window !== 'undefined') {
        window.__TI_REAUTH_PROMISE__ = promise;
    }
}
export default function createReauthHandler(reauthService, apiContext) {
    let reauthPromise = Promise.resolve();
    let nextAllowedReauth = new Date().getTime();
    setGlobalReauthPromise(reauthPromise);
    return function reauth(serviceFuncWithReauth) {
        const reauthHandler = () => {
            nextAllowedReauth = new Date().getTime() + reauthDebouncerThreshold;
            return performReauth(reauthService, apiContext);
        };
        if (new Date().getTime() < nextAllowedReauth) {
            const secondCallHandler = () => serviceFuncWithReauth(reauthHandler);
            reauthPromise = reauthPromise.then(secondCallHandler, secondCallHandler);
            setGlobalReauthPromise(reauthPromise);
            return reauthPromise;
        }
        reauthPromise = reauthPromise.then(reauthHandler, reauthHandler);
        setGlobalReauthPromise(reauthPromise);
        return reauthPromise;
    };
}
